// extracted by mini-css-extract-plugin
module.exports = {"blockInner":"BlogBlockContainer_blockInner__SeyAt","useFade-fadeIn":"BlogBlockContainer_useFade-fadeIn__O0iVy","useFade-fadeOut":"BlogBlockContainer_useFade-fadeOut__wP3OY"};